export var PARTNER_PROFILE_DEMOGRAPHICS_MEETING_NOMINEE_SEGMENT_DATA = "PARTNER_PROFILE_DEMOGRAPHICS_MEETING_NOMINEE_SEGMENT_DATA";
export var PARTNER_BANK_DATA = "PARTNER_BANK_DATA";
export var PARTNER_REGIS_DATA = "PARTNER_REGIS_DATA";
export var PARTNER_CERTIFICATION_DATA = "PARTNER_CERTIFICATION_DATA";
